t = require('app/scripts/views/internal/teacup-with-helpers')('board')

module.exports = ->
  t.div '.board-main-content', ->
    t.div '.board-header.u-clearfix.js-board-header'
    t.div '.board-warnings.u-clearfix.js-board-warnings'
    t.div '.board-canvas'

  t.div '.board-menu.js-fill-board-menu'
